/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	QualificationEnum,
	QualificationEnumFromJSON,
	QualificationEnumFromJSONTyped,
	QualificationEnumToJSON,
} from "./QualificationEnum";

/**
 *
 * @export
 * @interface UpdateEvaluationDTO
 */
export interface UpdateEvaluationDTO {
	/**
	 *
	 * @type {string}
	 * @memberof UpdateEvaluationDTO
	 */
	academicUserId?: string;
	/**
	 *
	 * @type {number}
	 * @memberof UpdateEvaluationDTO
	 */
	selfEvaluationScore1?: number;
	/**
	 *
	 * @type {number}
	 * @memberof UpdateEvaluationDTO
	 */
	selfEvaluationScore2?: number;
	/**
	 *
	 * @type {number}
	 * @memberof UpdateEvaluationDTO
	 */
	peerEvaluationScore?: number;
	/**
	 *
	 * @type {number}
	 * @memberof UpdateEvaluationDTO
	 */
	studentEvaluationScore?: number;
	/**
	 *
	 * @type {QualificationEnum}
	 * @memberof UpdateEvaluationDTO
	 */
	departmentDirectorQualification?: QualificationEnum;
}

export function UpdateEvaluationDTOFromJSON(json: any): UpdateEvaluationDTO {
	return UpdateEvaluationDTOFromJSONTyped(json, false);
}

export function UpdateEvaluationDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): UpdateEvaluationDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		academicUserId: !exists(json, "academicUserId")
			? undefined
			: json["academicUserId"],
		selfEvaluationScore1: !exists(json, "selfEvaluationScore1")
			? undefined
			: json["selfEvaluationScore1"],
		selfEvaluationScore2: !exists(json, "selfEvaluationScore2")
			? undefined
			: json["selfEvaluationScore2"],
		peerEvaluationScore: !exists(json, "peerEvaluationScore")
			? undefined
			: json["peerEvaluationScore"],
		studentEvaluationScore: !exists(json, "studentEvaluationScore")
			? undefined
			: json["studentEvaluationScore"],
		departmentDirectorQualification: !exists(
			json,
			"departmentDirectorQualification"
		)
			? undefined
			: QualificationEnumFromJSON(json["departmentDirectorQualification"]),
	};
}

export function UpdateEvaluationDTOToJSON(
	value?: UpdateEvaluationDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		academicUserId: value.academicUserId,
		selfEvaluationScore1: value.selfEvaluationScore1,
		selfEvaluationScore2: value.selfEvaluationScore2,
		peerEvaluationScore: value.peerEvaluationScore,
		studentEvaluationScore: value.studentEvaluationScore,
		departmentDirectorQualification: QualificationEnumToJSON(
			value.departmentDirectorQualification
		),
	};
}
